import "./StoreCard.css";

const StoreCard = ({ image, heading, paragraph }) => {
  return (
    <div className="store-card">
      <div className="store-card-img-wrapper">
        <img src={image} alt={heading} className="store-card-img" />
      </div>
      <h3 className="store-card-heading black-text-clip">{heading}</h3>
      <p className="store-card-paragraph black-text-clip filter-brightness">
        {paragraph}
      </p>
    </div>
  );
};

export default StoreCard;
